let language = {
    "97110101": "Not enough space of library",
    "97110010": "Root catalog does not exist",
    "97110011": "Catalog doesn't exist!",
    "97110019": "The library does not belong to the current user",

    "15800101": 'Illegal file name, The file name cannot contain any of the following characters: \\ \/ \: \* \? \" \< \> \|',
    "15800102": "The uploaded file is not of image type",
    "15800105": "System error",
    "fileUploadNetWorkError": 'Network connection error, please check network connection status and retry later.',
    "fileUploadUnknownError": 'Unknown error',
}

export { language }